export default {
    // 用户信息
    getMenuInfo: {
        action: "query",
        //resourceId: "oauth_getMenu",
        //path: '/getMenuData',
        resourceId: "oauth_getMenu",
        path: '/getMenuInfo',
        method: 'get',
        check: false
    },

    clearSession: {
        action: "query",
        resourceId: "swich_pos",
        path: '/oauth/clear/session',
        method: 'get',
        check: false
    },

    // 腰带
    RESOURCEINFO: {
        action: "query",
        resourceId: "RESOURCEINFO",
        path: '/getResourceInfo',
        method: 'get',
        check: false
    },

    // 退出
    oauth_logout: {
        action: "query",
        resourceId: "oauth_logout",
        path: '/oauth/logout',
        method: 'get',
        check: false
    },

    // 经销商选择
    SELECT_DEALER: {
        action: "query",
        path: '/set/position',
        resourceId: "select_position",
        method: 'post',
        check: false
    },

    // 582
    SET_VERIFICATION: {
        action: "query",
        path: '/set/verification',
        resourceId: "123",
        method: 'post',
        check: false
    }
}